import { Injectable, inject } from '@angular/core';

import { DatePipe } from '@angular/common';
import { Globals } from '../../globals.service';
import { LogType } from './logtype';
@Injectable()
export class LogService {
  private globals = inject(Globals);
  private datePipe = inject(DatePipe);

  logGroupStart(any: any, type: LogType, customHeader: string = null, requestName: string) {
    this.log(any, type, customHeader, LogGroup.START, requestName);
  }
  logGroupEnd(any: any, type: LogType, customHeader: string = null) {
    this.log(any, type, customHeader, LogGroup.END);
  }
  log(
    any: any,
    type: LogType,
    customHeader: string = null,
    logGroup: LogGroup = LogGroup.END,
    groupTitle: string = ''
  ) {
    if (!this.globals.DEBUG_MODE) {
      return;
    }
    let foreground = 'black';
    let background = 'white';
    let prefix = '';
    switch (type) {
      case LogType.INFO:
        prefix = customHeader === null ? 'INFO:' : customHeader;
        foreground = '#000000';
        background = '#E9F1DF';
        break;
      case LogType.ERROR:
        prefix = customHeader === null ? 'ERROR:' : customHeader;
        foreground = '#FFFFFF';
        background = '#F23C50';
        break;
      case LogType.WARNING:
        prefix = customHeader === null ? 'WARNING:' : customHeader;
        foreground = '#000000';
        background = '#FFCB05';
        break;
      case LogType.REQUEST:
        prefix = customHeader === null ? 'REQUEST:' : customHeader;
        foreground = '#000000';
        background = '#4AD9D9';
        break;
      case LogType.RESPONSE:
        prefix = customHeader === null ? 'RESPONSE:' : customHeader;
        foreground = '#000000';
        background = '#36B1BF';
        break;
      default:
        background = background;
    }
    prefix = '[' + this.datePipe.transform(Date.now(), 'HH:mm:ss.SSS') + '] ' + prefix;
    const stringToLog = '%c' + prefix + '\r\n' + JSON.stringify(any);
    const logColor = 'color:' + foreground + ';background-color:' + background + ';padding:10px;';
    const headerColor = 'background-color:' + background;
    switch (logGroup) {
      case LogGroup.START:
        console.groupCollapsed('%c' + groupTitle, headerColor);
        console.log(stringToLog, logColor);
        this.logBody(any);
        break;
      case LogGroup.ENTRY:
        console.log(stringToLog, logColor);
        this.logBody(any);
        break;
      case LogGroup.END:
        //console.log(stringToLog, logColor);
        this.logBody(any);
        console.groupEnd();
        break;
    }
  }
  logBody(any: any) {
    if (any !== undefined && any !== null && any.body !== undefined && any.body !== null) {
      console.table(any.body);
    }
  }
  //#endregion
}
export enum LogGroup {
  ENTRY = 0,
  START = 1,
  END = 2,
}
